import { useEffect, useState } from 'react'

export const useDesktopMediaQuery = () => {
  const [onDesktop, updateDesktopQuery] = useState(true)
  useEffect(() => {
    const mql = window.matchMedia('(min-width:1024px)')
    updateDesktopQuery(mql.matches)
    mql.onchange = (event) => {
      updateDesktopQuery(event.matches)
    }
    return () => {
      mql.onchange = null
    }
  }, [])

  return onDesktop
}
